module.exports = __webpack_public_path__ + "static/media/more.6117018d.svg";